'use client';

import { useState, useEffect } from 'react';

const STORAGE_KEY = 'xynth_cookie_consent';

export type CookieConsent = 'accepted' | 'declined' | null;

export function getCookieConsent(): CookieConsent {
  if (typeof window === 'undefined') return null;
  const val = localStorage.getItem(STORAGE_KEY);
  if (val === 'accepted' || val === 'declined') return val;
  return null;
}

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Only show if user hasn't made a choice yet
    if (!getCookieConsent()) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 sm:bottom-6 left-0 right-0 z-50 px-3 sm:px-4 animate-in slide-in-from-bottom-4 duration-300">
      <div className="max-w-lg mx-auto bg-zinc-900 border border-zinc-700 rounded-lg px-4 py-3 sm:px-5 sm:py-4 shadow-2xl flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
        <p className="text-xs sm:text-sm text-zinc-400">
          Xynth uses cookies for analytics and to improve your experience.{' '}
          <a href="/privacy" className="text-zinc-300 underline hover:text-zinc-100 transition-colors">
            Privacy Policy
          </a>
        </p>
        <div className="flex items-center gap-2 shrink-0 self-end">
          <button
            onClick={handleDecline}
            className="px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm text-zinc-400 hover:text-zinc-200 rounded-md transition-colors"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm font-medium bg-zinc-100 text-zinc-900 rounded-md hover:bg-white transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
